import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import './ChatActivity.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import RfiModalContainer from 'components/admin/projects/details/project-rfi-log/RfiModalContainer';
import SubmittalModalContainer from 'components/admin/projects/details/project-submittal-log/SubmittalModalContainer';
import ProjectOpenItemDetailsModal from 'components/admin/projects/details/project-open-items/ProjectOpenItemDetailsModal';
import { getCurrentUser } from 'selectors/authentication';
import { getChatActivity } from 'components/admin/chats/store/selectors';
import { loadProjectRequest } from 'components/admin/projects/details/store/actions';
import { openRfi } from 'components/admin/projects/details/project-rfi-log/store/actions';
import { openSubmittal } from 'components/admin/projects/details/project-submittal-log/store/actions';
import {
  loadOpenItem,
  setOpenItemsCritical,
} from 'components/admin/projects/details/project-open-items/store/actions';
import { chatActivityRequest } from 'components/admin/chats/store/actions';

class ChatActivity extends Component {
  static propTypes = {
    filters: PropTypes.shape(),
  };

  static defaultProps = {
    filters: { per_page: 5 },
  };

  constructor(props) {
    super(props);

    this.state = { showModal: null };
  }

  componentDidMount() {
    this.loadChatActivity(1);
  }

  scrollToTop = () => {
    if (this.chatActContentEl) {
      this.chatActContentEl.scrollTop = 0;
    }
  };

  loadChatActivity = (page) => {
    const { filters, dispatch } = this.props;
    dispatch(chatActivityRequest({ ...filters, page })).then(
      (response) => response.ok && this.scrollToTop()
    );
  };

  closeModal = () => {
    this.setState({ showModal: null });
  };

  openModal = (chat) => {
    const { currentUser, dispatch } = this.props;
    const subject = chat.notifiable;
    this.setState({ showModal: chat.notifiable_type });
    dispatch(loadProjectRequest(subject.project_id));
    switch (chat.notifiable_type) {
      case 'Rfi':
        return dispatch(openRfi(subject.project_id, subject.id));

      case 'Submittal':
        return dispatch(
          openSubmittal(subject.project_id, subject.id, currentUser)
        );

      case 'ProjectOpenItem':
        dispatch(setOpenItemsCritical(subject.critical));
        return dispatch(loadOpenItem(subject.project_id, subject.id));

      default:
        return null;
    }
  };

  open = (id) => {
    const { chatActivity, dispatch } = this.props;
    const chat = chatActivity.activity.find((chat) => chat.id === id);
    const subject = chat.notifiable;
    switch (chat.notifiable_type) {
      case 'Rfi':
      case 'Submittal':
      case 'ProjectOpenItem':
        return this.openModal(chat);

      case 'WorkOrder':
        return dispatch(push(`/admin/work-orders/${subject.id}`));

      case 'Task':
        return dispatch(
          push(`/admin/work-orders/${subject.work_order_id}/task/${subject.id}`)
        );

      default:
        return null;
    }
  };

  handleGenerateLink = (id) => {
    const { chatActivity } = this.props;
    const chat = chatActivity.activity.find((chat) => chat.id === id);
    const subject = chat.notifiable;
    switch (chat.notifiable_type) {
      case 'Rfi':
        return `projects/${subject.project_id}?rfiId=${subject.id}`;

      case 'Submittal':
        return `projects/${subject.project_id}?submittalId=${subject.id}`;

      case 'ProjectOpenItem':
        return `projects/${subject.project_id}?projectOpenItemId=${subject.id}`;

      case 'WorkOrder':
        return `work-orders/${subject.id}`;

      case 'Task':
        return `work-orders/${subject.work_order_id}/task/${subject.id}`;

      default:
        return null;
    }
  };

  subText = (title, maxLength = 30) => {
    return title.length > maxLength
      ? `${title.substring(0, maxLength)}...`
      : title;
  };

  buildUserName = (chat) => {
    const { user } = chat;
    return this.subText(
      `${user.first_name} ${user.last_name ? `${user.last_name[0]}.` : ''}`
    );
  };

  buildSubject = (chat) => {
    const subject = chat.notifiable;
    switch (chat.notifiable_type) {
      case 'Rfi':
        return (
          <div>
            <div>
              <b>
                {this.subText(
                  `RFI #${subject.number} - ${subject.project_name}`
                )}
              </b>
            </div>
            <div>
              <b>{this.subText(subject.title)}</b>
            </div>
            <div>{this.subText(chat.content)}</div>
          </div>
        );

      case 'Submittal':
        return (
          <div>
            <div>
              <b>
                {this.subText(
                  `Submittal #${subject.division}-${subject.number} - ${subject.project_name}`
                )}
              </b>
            </div>
            <div>
              <b>{this.subText(subject.title)}</b>
            </div>
            <div>{this.subText(chat.content)}</div>
          </div>
        );

      case 'ProjectOpenItem':
        return (
          <div>
            <div>
              <b>
                {this.subText(
                  `Open Item #${subject.number} - ${subject.project_name}`
                )}
              </b>
            </div>
            <div>
              <b>{this.subText(subject.description)}</b>
            </div>
            <div>{this.subText(chat.content)}</div>
          </div>
        );

      case 'WorkOrder':
        return (
          <div>
            <div>
              <b>
                {this.subText(
                  `WO #${subject.number} ${
                    subject.name ? `- ${subject.name}` : ''
                  }`
                )}
              </b>
            </div>
            <div>{this.subText(chat.content)}</div>
          </div>
        );

      case 'Task':
        return (
          <div>
            <div>
              <b>
                {this.subText(`WO #${subject.wo_number} Task ${subject.name}`)}
              </b>
            </div>
            <div>{this.subText(chat.content)}</div>
          </div>
        );

      default:
        return '';
    }
  };

  mapActivity = () => {
    const { chatActivity } = this.props;
    return chatActivity.activity.map((chat) => {
      return {
        id: chat.id,
        data: [this.buildUserName(chat), this.buildSubject(chat)],
      };
    });
  };

  render() {
    const { chatActivity } = this.props;
    const { showModal } = this.state;
    return (
      chatActivity && (
        <div className="chat-activity">
          <div className="chat-activity-title">
            <div>Chat</div>
            <div className="chat-activity-total">{chatActivity.total}</div>
          </div>
          <div
            className="chat-activity-content"
            ref={(el) => (this.chatActContentEl = el)}
          >
            <SimpleTable
              className="projects-table"
              headers={['USER', 'SUBJECT']}
              rows={this.mapActivity()}
              emptyMessage="No Activity."
              onRowSelected={this.open}
              onGenerateLink={this.handleGenerateLink}
            />
          </div>
          <div className="pagination-container">
            <SimplePagination
              currentPage={chatActivity.currentPage}
              pageSize={chatActivity.pageSize}
              total={chatActivity.total}
              onPageChange={this.loadChatActivity}
            />
          </div>

          {showModal === 'Rfi' && (
            <RfiModalContainer onClose={this.closeModal} />
          )}
          {showModal === 'Submittal' && (
            <SubmittalModalContainer onClose={this.closeModal} />
          )}
          {showModal === 'ProjectOpenItem' && (
            <ProjectOpenItemDetailsModal onClose={this.closeModal} />
          )}
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    chatActivity: getChatActivity(state),
  };
})(ChatActivity);



// WEBPACK FOOTER //
// ./src/components/admin/chats/ChatActivity.js